<template>
  <div style="display: inline-block;">
    {{ scope.row.nodeName }}
    <span v-if="scope.row.productInitListVO &&
      scope.row.productInitListVO != null"
    >
      <span v-if="scope.row.optionalType==1 &&
        scope.row.propertyCode === '1001'"
      >
        <span class="promotion">
          <img src="@/assets/selectProduct.png" alt="err">
        </span>
      </span>
      <span v-if="scope.row.standardFlag==1">
        <span class="promotion">
          <img src="@/assets/newImport.png" alt="err">
        </span>
      </span>
      <span v-if=" scope.row.productInitListVO.isDiscount && !isPartner">
        <span class="promotion">
          <img src="@/assets/promotion-new.png" alt="err">
        </span>
      </span>
      <span v-if="isControlled(scope.row.productInitListVO)">
        <span class="promotion">
          <img src="@/assets/controlled-new.png" alt="err">
        </span>
      </span>
      <span v-if="isNewProduct(scope.row.productInitListVO)">
        <span class="promotion">
          <img src="@/assets/newproduct-new.png" alt="err">
        </span>
      </span>
      <span
        v-if="scope.row.productInitListVO.industryIsEnabled==false"
        class="promotion"
      >
        <img src="@/assets/shelves-new.png" alt="err">
      </span>
      <span
        v-if="scope.row.productInitListVO.quotation==1"
        class="promotion2"
      >
        <img src="@/assets/fuwushang-new.png" alt="err">
      </span>
      <span v-if="scope.row.productInitListVO.quotation==2 &&
              getStore('industryFlg') == 1"
            class="promotion2"
      >
        <img src="@/assets/fuwushang-new.png" alt="err">
      </span>
    </span>
  </div>
</template>

<script>
import api from '../../api';
import { setStore, getStore, isPartnerM, isNotNull, removeStore, isControlled, isNewProduct, isOrNoCollection } from '@/utils/mUtils';
export default {
  name: 'PreciseProductNameFormation',
  props: {
    scope: {
      type: Object,
      default: () => {}
    }
  },
  components: {},
  data () {
    return {
      isPartner: true
    };
  },
  mounted () {
    this.isPartner = isPartnerM();
  },
  methods: {
    isPartnerM, isNotNull, removeStore, isControlled, isNewProduct, isOrNoCollection, getStore
  }
};
</script>

<style scoped>
  .promotion{
    width: 32px;
    height: 20px;
    display: inline-block;
  }
  .promotion img{
    width: 32px;
    height: 20px;
    vertical-align: middle;
  }

  .promotion:hover img{
    width: 35px;
    vertical-align: middle;
  }

  .promotion2{
    width: 40px;
    height: 20px;
    display: inline-block;
  }
  .promotion2 img{
    width: 40px;
    height: 20px;
    vertical-align: middle;
  }
  .promotion2:hover img{
    width: 45px;
    vertical-align: middle;
  }
</style>
